import Multiselect from "multiselect-react-dropdown";
import { Controller } from "react-hook-form";
import { REQ_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
interface ListItem {
  category: string;
  key: string;
}
interface multipleCheckboxDropdownGroupProps {
  control?: any;
  optionsList?: any[];
  className?: string;
  name: string;
  watchData?: any;
  errors?: any;
  required: boolean;
}
export default function MultipleCheckboxDropdownGroup(
  props: multipleCheckboxDropdownGroupProps
) {
  const {
    control,
    name,
    optionsList,
    className,
    watchData,
    required = false,
    errors,
  } = props;
  let inputClassName = className || '';
  if (errors) {
    inputClassName += ' border-danger'; 
  }
  return (
    <div>
      <Controller
        control={control}
        name={name}
        rules={{ required: { value: required, message: REQ_ERR_MSG } }}
        render={({ field: { value, onChange } }) => (
          <Multiselect
          customCloseIcon={<><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#29afe8" className="bi bi-x-circle-fill ms-2" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
        </svg></>}
            className={inputClassName}
            displayValue="key"
            groupBy="category"
            options={optionsList}
            selectedValues={value} // Pass the selected values to the Multiselect
            onSelect={(selectedList: ListItem[], selectedItem: ListItem) => {
              onChange(selectedList);
            }}
            onRemove={(selectedList: ListItem[], removedItem: ListItem) => {
              const updatedList = selectedList.filter(
                (item: ListItem) => item !== removedItem
              );
              onChange(updatedList);
            }}
            showCheckbox
            disable={watchData}
            placeholder={
              value && value.length > 0 ? "" : "Select"
            }
          />
        )}
      />
      {errors && (
        <div>
          <span className="text-danger">{errors.message}</span>
        </div>
      )}
    </div>
  );
}
